import { render, staticRenderFns } from "./ApmsBasicFarmingCategory.vue?vue&type=template&id=092be794&scoped=true&"
import script from "./ApmsBasicFarmingCategory.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicFarmingCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092be794",
  null
  
)

export default component.exports